import { Resource as e } from "@coveo/platform-client";
const s = class s extends e {
  /**
   * Returns the current automation freezes
   */
  listFreezes() {
    return this.api.get(s.baseUrl);
  }
};
s.baseUrl = "/rest/indexautomation/freezes";
let t = s;
export {
  t as AutomationFreezesResource
};
//# sourceMappingURL=AutomationFreezesResource.js.map
